import * as React from "react";
import { FC } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";


import { connectWithNotification, INotificationContainerProps } from "@montana/containers/notification";

import { Portal } from "@montana/shared/portal";
import { Timing } from "@montana/constants/animation";

import { Notification } from "./notification";

const TRANSITION_DURATION = Timing.STANDARD;

const GlobalNotificationsComponent: FC<INotificationContainerProps> = React.memo(({ notifications, removeNotification }: INotificationContainerProps) => {
    return (
        <Portal className="global-notifications">
            <TransitionGroup className="global-notifications__notifications-container">
                {Array.isArray(notifications) && notifications.map(n => (
                    <CSSTransition key={n.timeStamp} timeout={TRANSITION_DURATION} classNames="global-notifications__notification">
                        <Notification
                            className="global-notifications__notification"
                            notification={n}
                            onClose={() => removeNotification(n.timeStamp)}
                            style={{ transitionDuration: `${TRANSITION_DURATION}ms` }} />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        </Portal>
    );
});

export const GlobalNotifications = connectWithNotification(GlobalNotificationsComponent);
